var widthFull = {
  "width": "100%"
};

export { widthFull };
